import { render, staticRenderFns } from "./TOne.vue?vue&type=template&id=52bd67de&scoped=true&"
import script from "./TOne.vue?vue&type=script&lang=js&"
export * from "./TOne.vue?vue&type=script&lang=js&"
import style0 from "./TOne.vue?vue&type=style&index=0&id=52bd67de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd67de",
  null
  
)

export default component.exports